module.exports = __webpack_public_path__ + "img/circle_alert_three.8ef6556d.svg";